import { openDB } from 'idb';

const DB_NAME = 'rg-massive-offline';
const DB_VERSION = 1;

export const dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
        if (!db.objectStoreNames.contains('offline_queue')) {
            db.createObjectStore('offline_queue', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('local_data')) {
            db.createObjectStore('local_data', { keyPath: 'key' });
        }
    },
});

export const OfflineDatabase = {
    async addToQueue(requestData) {
        const db = await dbPromise;
        return db.add('offline_queue', requestData);
    },

    async getQueue() {
        const db = await dbPromise;
        return db.getAll('offline_queue');
    },

    async removeFromQueue(id) {
        const db = await dbPromise;
        return db.delete('offline_queue', id);
    },

    async setLocalData(key, value) {
        const db = await dbPromise;
        return db.put('local_data', { key, value });
    },

    async getLocalData(key) {
        const db = await dbPromise;
        const data = await db.get('local_data', key);
        return data ? data.value : null;
    }
};
